export default {"src":"/_next/static/media/infinity_24.00ad52a6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};